import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {patchStoreAd} from './patchStoreAd';

export interface IPatchStoreAdPayload {
  advertisementGuid: string;
  availableQuantity: number;
}

const usePatchStoreAd = (
  handleAfterSuccess?: (variables: IPatchStoreAdPayload) => void,
) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPatchStoreAdPayload) => patchStoreAd(payload),

    onSuccess: (_, variables) => {
      handleAfterSuccess?.(variables);
      queryClient.invalidateQueries(['get-my-store-ads']);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePatchStoreAd;
